// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as Json from "melange-json/Json.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__State from "./state.jsx";

const replay_gain_local_storage_key = "replayGain";

function make(param) {
  const replayGainOptions = Stdlib__Option.value(Stdlib__Option.map((function (param) {
    return Stdlib__Fun.compose(Store__State.ReplayGainOptions.of_json, Json.parseOrRaise, param);
  }), Caml_option.null_to_opt(localStorage.getItem(replay_gain_local_storage_key))), {
    preAmp: 0.0,
    preferredGain: undefined
  });
  return {
    buffered: [],
    currentSongId: undefined,
    currentTime: 0.0,
    duration: undefined,
    muted: false,
    paused: true,
    queuedSongIds: [],
    replayGainOptions: replayGainOptions,
    volume: 1.0
  };
}

export {
  replay_gain_local_storage_key,
  make,
}
/* Json Not a pure module */
